import { useTranslation } from 'react-i18next';

import { Paragraph, CarouselItem } from '@app/shared/ui/atoms/Common';
import {
  BannerContentContainer,
  PlaceholderBanner,
  TextBanner,
} from '@app/shared/ui/molecules/Home';
import { BannerPlaceholder, BannerText } from '@app/shared/types/pages/home';

type BannerCardProps = {
  banner: BannerText | BannerPlaceholder;
};

export function BannerCard({ banner }: BannerCardProps) {
  const { t } = useTranslation();

  return (
    <CarouselItem
      className="flex flex-col rounded-xl bg-cover bg-center p-3"
      style={{ backgroundImage: `url(${banner.img})` }}
    >
      <BannerContentContainer containerClassname={banner.button && 'h-full'}>
        {banner.variant === 'text' && (
          <TextBanner
            title={banner.text?.title}
            description={banner.text?.description}
            buttonText={banner.button?.text}
            onBtnClick={banner.button?.onClick}
          />
        )}

        {banner.variant === 'placeholder' && (
          <PlaceholderBanner
            placeholder={banner.placeholder}
            buttonText={banner.button?.text}
            onBtnClick={banner.button?.onClick}
          />
        )}

        {banner.soon && (
          <Paragraph variant="white" size="xl" className="text-shadow-dark">
            {t('common.soon')}
          </Paragraph>
        )}
      </BannerContentContainer>
    </CarouselItem>
  );
}
